export default __webpack_public_path__ + "static/7465-3f5078301941ec201a86ec56de0b3e3c.jpg";